import React from 'react'

export type KambiHistoryCouponDisplayContextType =
  | {
      type: 'betloop'
      data?: { cashedOutAtUtc?: string | null }
      utils?: Partial<{ handleDisableCopyBet(): void }>
    }
  | {
      type: 'betloop-quick-share'
      data: { isSelected: boolean }
      utils?: never
    }
  | {
      type: 'external-share'
      data?: { cashedOutAtUtc?: string | null }
      utils?: never
    }
  | {
      type: 'bet-history'
      data: { location: 'event-card' | 'bet-history' }
      utils?: never
    }

/** Handles different display variations for BetInfo child components
 *  @default type: 'bet-loop' */
export const KambiHistoryCouponDisplayContext =
  React.createContext<KambiHistoryCouponDisplayContextType>({ type: 'betloop' })
